import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { SEO } from "@/components/SEO";
import { Home, ArrowLeft, BookOpen } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col relative">
      <SEO
        title="Page introuvable | Easy Taxes"
        description="Cette page n'existe pas ou a été déplacée. Retrouvez nos services de déclaration d'impôts en Suisse."
        noindex={true}
      />
      {/* Apple Vision depth orbs */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden z-0">
        <div 
          className="absolute -top-40 -left-40 w-[600px] h-[600px] rounded-full"
          style={{ background: 'radial-gradient(circle, rgba(220, 235, 228, 0.4) 0%, transparent 70%)' }}
        />
        <div 
          className="absolute top-1/2 -right-60 w-[500px] h-[500px] rounded-full"
          style={{ background: 'radial-gradient(circle, rgba(201, 164, 76, 0.06) 0%, transparent 60%)' }}
        />
        <div 
          className="absolute -bottom-60 -right-40 w-[700px] h-[700px] rounded-full"
          style={{ background: 'radial-gradient(circle, rgba(201, 164, 76, 0.08) 0%, transparent 60%)' }}
        />
      </div>

      <Navigation />
      
      <main 
        className="flex-1 flex items-center justify-center relative z-10 py-24"
        style={{ background: 'linear-gradient(180deg, #F5F7F4 0%, #E9EFEA 50%, #F2F5F3 100%)' }}
      >
        <div className="container-custom">
          <div className="apple-glass rounded-3xl p-8 md:p-12 lg:p-16 max-w-2xl mx-auto text-center">
            {/* 404 Number */}
            <div className="mb-6">
              <span 
                className="text-8xl md:text-9xl font-heading font-bold bg-gradient-to-br from-green-primary to-green-secondary bg-clip-text text-transparent"
              >
                404
              </span>
            </div>

            {/* Message */}
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-green-primary mb-4">
              Page introuvable
            </h1>
            <p className="text-lg text-muted-foreground mb-8 max-w-md mx-auto">
              Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
            </p>

            {/* Actions */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/">
                <Button variant="cta" size="lg" className="gap-2">
                  <Home className="w-5 h-5" />
                  Retour à l'accueil
                </Button>
              </Link>
              <Button 
                variant="outline" 
                size="lg" 
                className="gap-2"
                onClick={() => window.history.back()}
              >
                <ArrowLeft className="w-5 h-5" />
                Page précédente
              </Button>
            </div>
            
            {/* Blog link for SEO recovery */}
            <div className="mt-6 pt-6 border-t border-green-pastel/30">
              <Link to="/blog" className="inline-flex items-center gap-2 text-green-secondary hover:text-green-primary transition-colors">
                <BookOpen className="w-4 h-4" />
                <span>Découvrir nos guides fiscaux</span>
              </Link>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default NotFound;